import { render, staticRenderFns } from "./First.vue?vue&type=template&id=6f60200d"
import script from "./First.vue?vue&type=script&lang=ts"
export * from "./First.vue?vue&type=script&lang=ts"
import style0 from "./First.vue?vue&type=style&index=0&id=6f60200d&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports